import * as React from 'react';
import { useCallback } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { ILocMsgInfo } from '../../../../models/IChatMessage';
import { IStore } from '../../../../redux/initialState';
import * as scriptEditorActions from '../../../../redux/scriptEditor/actions.scriptEditor';
import { IHighlightLineParams } from '../../../../redux/scriptEditor/actions.scriptEditor';
import ToasterService from '../../../../services/ToasterService';
import { FileLineLocInfoTypes } from './FileLineLocInfoTypes';
import device from '../../../../services/mini/device';

type FileLineLocInfoProps = FileLineLocInfoReduxProps & {
    type: FileLineLocInfoTypes
    locData: ILocMsgInfo
    className?: string
    visualStateIndex?: number
    onAfterClick?: (e: React.MouseEvent) => void
    onMouseEnter?: (e: React.MouseEvent) => void
    onMouseLeave?: (e: React.MouseEvent) => void
}

function FileLineLocInfo({ project, className, locData = { file: null, line: null }, type, visualStateIndex, onMouseEnter, onMouseLeave, highlightLine, onAfterClick }: FileLineLocInfoProps) {

    let externalClass = '';
    let contentClass = '';
    let contentWrapperClass = '';
    let fileClass = '';
    let lineClass = '';

    if (type === FileLineLocInfoTypes.Response) {
        externalClass = 'chat-bubble_r-Loc';
        contentClass = 'r-Loc_cont';
        contentWrapperClass = 'r-Loc_wrapper';
        fileClass = 'r-Loc_link';
        lineClass = 'r-Loc_num';
    } else if (type === FileLineLocInfoTypes.Request) {
        externalClass = 'chat-bubble_p-Loc';
        contentClass = 'p-Loc_cont';
        contentWrapperClass = 'p-Loc_wrapper';
        fileClass = 'p-Loc_link';
        lineClass = 'p-Loc_num';
    }

    const highlightLineCb = React.useCallback((e) => {
        if (device.isDesktop()) {
            if (locData) {
                highlightLine({
                    scriptName: locData.file,
                    lineNumber: locData.line,
                    lineType: type,
                    project,
                    character: 0,
                });
            }
        } else {
            ToasterService.showInfo({ title: 'Navigation to intents is available only on desktops. Use Alan AI Studio within a desktop browser for a better experience' });
        }

        if (onAfterClick) {
            onAfterClick(e);
        }

    }, [highlightLine, locData, onAfterClick, project, type]);

    const hasFileInfo = locData.file;

    const onMouseEnterCb = useCallback((e) => {
        if (onMouseEnter) {
            onMouseEnter(e);
        }
    }, [onMouseEnter]);

    const onMouseLeaveCb = useCallback((e) => {
        if (onMouseLeave) {
            onMouseLeave(e);
        }
    }, [onMouseLeave]);

    if (!hasFileInfo && !visualStateIndex) return <React.Fragment />;
    if (!hasFileInfo && visualStateIndex>=0) return <div className="file-line-loc-info__empty-part"></div>;

    return <div
        className={`${externalClass} ${className}`}
        onMouseEnter={onMouseEnterCb}
        onMouseLeave={onMouseLeaveCb}
        onClick={highlightLineCb}>
        {locData &&
            <div className={contentClass}>
                {type === FileLineLocInfoTypes.Response && <i className="icon icon-alan-output-sign" />}
                {type === FileLineLocInfoTypes.Request && <i className="icon icon-alan-input-sign" />}
                {hasFileInfo && <div className={contentWrapperClass} title={`${locData.file}: ${locData.line}`}>
                    <span className={fileClass}>{`${locData.file}`}</span>
                </div>}
                {locData.line && <span className={lineClass}>{` :${locData.line}`}</span>}
            </div>
        }
    </div>;
}

function mapStateToProps({ projectsInfo }: IStore) {
    return {
        project: projectsInfo.currentProject,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        highlightLine: (param: IHighlightLineParams) => dispatch(scriptEditorActions.highlightLine(param)),
    };
}


const connector = connect(mapStateToProps, mapDispatchToProps);

type FileLineLocInfoReduxProps = ConnectedProps<typeof connector>;

export default connector(FileLineLocInfo);